module.exports = {
  text: `Они придумывают своих собственных богов… Это по определению безумие`,
  author: `Сабал Миззрим из Мензоберранзана`,
}
